import { PlantLayoutAreaDrawingsThemeModeConfig } from './types';

const light: PlantLayoutAreaDrawingsThemeModeConfig = {
  plantLayoutAreaDrawings: {
    buttonContainerBackground: 'linear-gradient(to bottom, #33adff11, #0000FF22)',
    normalButtonBGColor: '#0775bc',
    normalButtonBorderColor: '2px solid #267DAC',
    arrowButtonBGColor: '#0775bc',
    activeButtonTextColor: 'black',
    inactiveButtonTextColor: 'white',
    activeButtonBGColor: '#99ffff',
    inactiveButtonBGColor: '#0775bc',
  },
};

export default light;
